import React from "react";
import { useI18n } from "@/contexts/I18nContext";
import { Waves } from "lucide-react";

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer data-testid="site-footer" className="mt-20 border-t border-[color:var(--hairline)] bg-[color:var(--sand-2)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 grid gap-6 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-3 mb-2">
            <img src="/brand/logo.png" alt="SJDS.app" className="w-14 h-14 rounded-2xl object-cover" />
            <div className="leading-tight">
              <p className="font-bold text-lg" style={{ fontFamily: "Outfit" }}>SJDS.app</p>
              <p className="text-[10px] uppercase tracking-[0.2em] text-[color:var(--ink-2)]">SanJuanDelSur.app</p>
            </div>
          </div>
          <p className="text-sm text-[color:var(--ink-2)] max-w-xs">
            {t("footer_location")}
          </p>
        </div>
        <div className="text-sm text-[color:var(--ink-2)]">
          <p className="eyebrow mb-2">{t("footer_data")}</p>
          <ul className="space-y-1">
            <li>{t("data_openmeteo")}</li>
            <li>{t("data_usgs")}</li>
            <li>{t("data_noaa")}</li>
            <li>{t("data_ineter")}</li>
          </ul>
        </div>
        <div className="text-sm text-[color:var(--ink-2)]">
          <p className="eyebrow mb-2">{t("footer_disclaimer")}</p>
          <p data-testid="disclaimer-text" className="leading-relaxed">
            {t("disclaimer")}
          </p>
        </div>
      </div>
      <div className="border-t border-[color:var(--hairline)] py-4 text-center text-xs text-[color:var(--ink-2)] space-y-1">
        <p>© {new Date().getFullYear()} SJDS.app · SanJuanDelSur.app</p>
        <p data-testid="footer-credit">
          {t("footer_credit")}{" "}
          <a
            href="https://www.GregMiceli.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-credit-link"
            className="font-semibold text-[color:var(--coral)] hover:underline"
          >
            www.GregMiceli.com
          </a>
        </p>
      </div>
    </footer>
  );
}
